import { Pipe, PipeTransform } from "@angular/core";
 import { AssessmentTypeNames } from "../../core/models/assessment-types.model";

@Pipe({
  name: 'studentPlacement',
  standalone: true,
})
export class StudentPlacementPipe implements PipeTransform {
  transform(activeAssesementType: number, highestCompletedAssessmentType: number, levelsCompleted: number) {
    if (highestCompletedAssessmentType === AssessmentTypeNames.POSTDIAGNOSTIC && levelsCompleted === 120) {
      return 'Completed'
    } else if (activeAssesementType === AssessmentTypeNames.SCREENER) {
      return 'Screener'
    } else if (activeAssesementType === AssessmentTypeNames.PREDIAGNOSTIC) {
      return 'Pre Diagnostic';
    } else if (activeAssesementType === AssessmentTypeNames.MIDDIAGNOSTIC) {
      return 'Mid Diagnostic';
    } else if (activeAssesementType === AssessmentTypeNames.POSTDIAGNOSTIC) {
      return 'Post Diagnostic';
    }
    const unit = Math.min(Math.floor(levelsCompleted / 5) + 1, 24);
    return 'Unit ' + unit;
  }
}
